function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "svg-lines",
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "line4",
  className: "line4",
  d: "M989.922 45L152 882.922",
  stroke: "url(#paint0_linear)",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "line3",
  className: "line3",
  d: "M378.922 180L-459 1017.92",
  stroke: "url(#paint1_linear)",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "line2",
  className: "line2",
  d: "M1566.92 17L494.948 1088.97",
  stroke: "url(#paint2_linear)",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "line1",
  className: "line1",
  d: "M1907.92 256L1070 1093.92",
  stroke: "url(#paint3_linear)",
  strokeWidth: 2,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 990.275,
  y1: 45.3536,
  x2: 152.354,
  y2: 883.275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#272A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272A31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 379.275,
  y1: 180.354,
  x2: -458.646,
  y2: 1018.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#272A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272A31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 1567.28,
  y1: 17.3536,
  x2: 495.302,
  y2: 1089.33,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#272A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272A31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 1908.28,
  y1: 256.354,
  x2: 1070.35,
  y2: 1094.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#272A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272A31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080,
  fill: "white"
})));

var SvgSvgLines = function SvgSvgLines(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSvgLines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/svg-lines.09ac2800.svg";
export { ForwardRef as ReactComponent };